<template>
  <div>
    <TheHeader />
    <div class="wrapper">
      <the-filters v-if="!isMobileFilter"/>
      <div class="container container_padding container_flex">
        <div class="block__left">
          <round-chart/>
          <the-summary/>
          <day-table/>
        </div>
        <div class="block__right">
          <main-table/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TheFilters from '../components/TheFilters';
  import RoundChart from '../components/RoundChart';
  import TheSummary from '../components/TheSummary';
  import DayTable from '../components/DayTable';
  import MainTable from '../components/MainTable';
  import TheHeader from '../components/TheHeader.vue';

  export default {
    name: 'Home',
    data: () => ({
      isMobileFilter: false,
    }),
    components: {
      MainTable,
      DayTable,
      TheSummary,
      RoundChart,
      TheFilters,
      TheHeader
    },
    mounted() {
      this.isMobileFilter = window.screen.width < 768;
    }
  };
</script>

<style lang="scss">
  @import "../assets/styles/main";
</style>
